/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import template from './line-item-list-summary.component.html';
import {APP_SHARED} from '../../common/app-shared';
import {LINE_ITEM_LABELS} from '../../line-item/line-item-labels';

@Component({
  standalone: true,
  imports: [...APP_SHARED, UIRouterModule, ...LINE_ITEM_LABELS],
  selector: 'adn-line-item-list-summary',
  template
})
export class LineItemListSummaryComponent {
  @Input() items: any[] = [];
}
